<div class="propero-home" *ngIf="config">
  <!-- Hero (compact, fără imagine) -->
  <section id="home" class="ph-hero ph-hero--compact">
    <div class="ph-hero__blob ph-hero__blob--brand" aria-hidden="true"></div>
    <div class="ph-hero__blob ph-hero__blob--accent" aria-hidden="true"></div>

    <div class="ph-container ph-hero__content--centered">
      <div class="ph-hero__badge">
        <span class="ph-hero__badge-dot" aria-hidden="true"></span>
        {{ config.heroEyebrowKey | translate }}
      </div>

      <h1 class="ph-hero__title">{{ tKey('TITLE') | translate }}</h1>
      <p class="ph-hero__subtitle">{{ heroSubtitleKey() | translate }}</p>

      <div class="ph-hero__actions ph-hero__actions--centered">
        <a [href]="assistantHref" target="_blank" rel="noopener noreferrer" class="ph-btn ph-btn--brand ph-btn--lg">
          Propero Assistant
        </a>
        <a routerLink="/solution-personalised" class="ph-btn ph-btn--outline ph-btn--lg">
          {{ 'HOME.MAIN_PERSONALIZED_OFFER' | translate }}
        </a>
      </div>
    </div>
  </section>

  <!-- Beneficii -->
  <section id="features" class="ph-section ph-section--muted">
    <div class="ph-container">
      <div class="ph-section__header ph-section__header--center">
        <h2 class="ph-section__title">{{ 'SOLUTION_GENERAL.BENEFITS_TITLE' | translate }}</h2>
      </div>

      <div class="ph-solutions__grid">
        <article *ngFor="let feature of config.shortFeatures" class="ph-solution-card">
          <div class="ph-solution-card__icon">
            <i class="lni" [ngClass]="feature.icon"></i>
          </div>
          <h3 class="ph-solution-card__title">{{ shortTitleKey(feature.index) | translate }}</h3>
          <p class="ph-solution-card__text">{{ shortTextKey(feature.index) | translate }}</p>
        </article>
      </div>

      <div class="ph-features__cta">
        <a [href]="assistantHref" target="_blank" rel="noopener noreferrer" class="ph-btn ph-btn--brand ph-btn--lg">
          {{ 'SOLUTION_GENERAL.CREATE_ACCOUNT' | translate }}
        </a>
        <button type="button" class="ph-btn ph-btn--outline ph-btn--lg" (click)="scrollToFaq()">
          {{ 'SOLUTION_GENERAL.VIEW_FAQ' | translate }}
        </button>
      </div>
    </div>
  </section>

  <!-- FAQ -->
  <section id="faq" class="ph-section">
    <div class="ph-container ph-container--narrow">
      <div class="ph-section__header ph-section__header--center">
        <h2 class="ph-section__title">{{ tKey('QA_TITLE') | translate }}</h2>
      </div>

      <div class="ph-faq">
        <div *ngFor="let item of config.faqItems; let i = index" class="ph-faq__item">
          <button
            type="button"
            class="ph-faq__trigger"
            (click)="toggleFaq(i)"
            [attr.aria-expanded]="openFaqIndex === i">
            <span>{{ questionKey(item.index) | translate }}</span>
            <i class="lni lni-chevron-down ph-faq__chevron" [class.ph-faq__chevron--open]="openFaqIndex === i"></i>
          </button>
          <div class="ph-faq__panel" *ngIf="openFaqIndex === i">
            <p>{{ questionAnswerKey(item.index) | translate }}</p>
          </div>
        </div>
      </div>
    </div>
  </section>

  <!-- Contact -->
  <section id="contact" class="ph-section ph-section--contact">
    <div class="ph-container ph-contact__grid">
      <div class="ph-contact__info">
        <h2 class="ph-contact__title">{{ 'HOME.SECTION_CONTACTUS_HEADING' | translate }}</h2>
        <p class="ph-contact__lead">{{ 'HOME.SECTION_CONTACTUS_TEXT' | translate }}</p>

        <div class="ph-contact__channels">
          <div class="ph-contact__channel">
            <div class="ph-contact__channel-icon"><i class="lni lni-phone"></i></div>
            <div>
              <div class="ph-contact__channel-label">Telefon</div>
              <div class="ph-contact__channel-value">{{ 'COMPANY.CONTACT_MAIN_PHONE' | translate }}</div>
            </div>
          </div>
          <div class="ph-contact__channel">
            <div class="ph-contact__channel-icon"><i class="lni lni-envelope"></i></div>
            <div>
              <div class="ph-contact__channel-label">Email</div>
              <div class="ph-contact__channel-value">{{ 'COMPANY.CONTACT_MAIN_EMAIL' | translate }}</div>
            </div>
          </div>
        </div>
      </div>

      <form #contactForm="ngForm" (ngSubmit)="send()" class="ph-contact__form" novalidate>
        <div class="ph-field">
          <label for="sol-contact-name">{{ 'HOME.NAME' | translate }}</label>
          <input
            id="sol-contact-name"
            type="text"
            name="name"
            [(ngModel)]="contactItem.subject"
            required
            [placeholder]="'HOME.NAME' | translate" />
        </div>
        <div class="ph-field">
          <label for="sol-contact-email">{{ 'HOME.EMAIL' | translate }}</label>
          <input
            id="sol-contact-email"
            type="email"
            name="email"
            [(ngModel)]="contactItem.email"
            required
            email
            [placeholder]="'HOME.EMAIL' | translate" />
        </div>
        <div class="ph-field">
          <label for="sol-contact-message">{{ 'HOME.MESSAGE' | translate }}</label>
          <textarea
            id="sol-contact-message"
            name="message"
            rows="4"
            [(ngModel)]="contactItem.content"
            required
            [placeholder]="'HOME.MESSAGE' | translate"></textarea>
        </div>
        <button type="submit" class="ph-btn ph-btn--brand ph-btn--block ph-btn--lg" [disabled]="contactForm.invalid || isLoading">
          <span *ngIf="!isLoading">{{ 'HOME.SEND' | translate }}</span>
          <span *ngIf="isLoading">{{ 'HOME.SENDING' | translate }}</span>
        </button>
        <p *ngIf="contactSuccess" class="ph-contact__success">{{ 'CONTACT.FORM.SUCCESS' | translate }}</p>
      </form>
    </div>
  </section>
</div>
